import { isWeekend, addDays, format, isSameDay } from 'date-fns';

export function dateRangeIsNotSequential({range, excludeWeekends, excludeHolidays, holidays}) {
    let allSequential = true;

    for (let i = 0; i < range.length - 1; i++) {
        const currentDate = range[i];
        const nextDate = range[i + 1];
        let expectedDate = addDays(currentDate, 1);

        if (excludeWeekends && isWeekend(expectedDate) && isSameDay(expectedDate, nextDate)) {
            allSequential = false;
            break;
        }

        const includesHoliday = holidays.includes(format(expectedDate, 'yyyy-MM-dd'));

        if (excludeHolidays && includesHoliday && isSameDay(expectedDate, nextDate)) {
            allSequential = false;
            break;
        }

        if (!isSameDay(expectedDate, nextDate)) {
            allSequential = false;
            break;
        }
    }

    return !allSequential;
}
